module.exports = __webpack_public_path__ + "static/media/todoLogo.f095c0a0.png";